import {
  emailOTPClient,
  genericOAuthClient,
  usernameClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

const AUTH_URL =
  import.meta.env.VITE_BETTER_AUTH_URL || "http://localhost:3001";

// BetterAuth client configuration
// This connects to the et-auth service for authentication
export const authClient = createAuthClient({
  baseURL: AUTH_URL,
  fetchOptions: {
    credentials: "include", // Required for cookie-based session
  },
  plugins: [usernameClient(), emailOTPClient(), genericOAuthClient()],
});

// Validate email before password reset OTP flow
// Returns: { valid: true } or { valid: false, error: "EMAIL_NOT_FOUND" | "GOOGLE_ACCOUNT" }
export async function validateResetEmail(
  email: string,
): Promise<{ valid: boolean; error?: string }> {
  const response = await fetch(`${AUTH_URL}/api/validate-reset-email`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ email }),
  });

  return response.json();
}

// Export individual methods for convenience
export const {
  signIn,
  signUp,
  signOut,
  useSession,
  getSession,
  updateUser,
  changePassword,
  emailOtp,
} = authClient;
